import {CSSProperties} from "react";

interface IShovelIcon {
    background?: string
    style?: CSSProperties
}

export function ShovelIcon({background = "white", style}: IShovelIcon) {
    return (
        <svg viewBox="0 0 32 32" fill="none" style={style}>
            <line x1="13.5" y1="3" x2="18.5" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <line x1="16" y1="3" x2="16" y2="20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
            <rect x="14" y="19" width="4" height="2.5" rx={0.8} fill="currentColor"/>
            <path d="M11 22 Q11 30.5 16 32 Q21 30.5 21 22 Z" fill="currentColor"/>
            <line x1="16" y1="23" x2="16" y2="29.5" stroke={background} strokeWidth="0.5" strokeLinecap="round"/>
            <path d="M8 30 L9.5 29.4 L11 30.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"
                  strokeLinejoin="round" fill="none" opacity={0.7}/>
            <path d="M21 30.2 L22.5 29.4 L24 30" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"
                  strokeLinejoin="round" fill="none" opacity={0.7}/>
        </svg>
    );
}
